type Maybe<T> = null | undefined | T;
export interface RemiErrorDeprecatedExtensionOptions {
  [attributeName: string]: unknown;
}
interface RemiErrorDeprecatedOptions {
  pkg?: Maybe<string>;
  path?: Maybe<string>;
  attributes?: Maybe<RemiErrorDeprecatedExtensionOptions>;
}
export interface RemiErrorDeprecatedInput {
  message: string;
  originalError?: Maybe<Error>;
  options?: RemiErrorDeprecatedOptions;
}

export type SentryErrorMetric =
  | {
      type: "counter";
      value?: number;
      name: string;
      attributes?: Record<string, unknown>;
    }
  | {
      type: "gauge";
      value: number;
      name: string;
      attributes?: Record<string, unknown>;
    }
  | {
      type: "distribution";
      value: number;
      name: string;
      attributes?: Record<string, unknown>;
    };

export const DEFAULT_ERROR_NAME = "RemiErrorDeprecated";
export const ERROR_SENTRY_DATA_PROPERTY = "__sentryData";
